import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { PDFViewerModule } from '@progress/kendo-angular-pdfviewer';

@Component({
    selector: 'qpoint-pdf-thumbnail',
    templateUrl: './q-point-pdf-thumbnail.component.html',
    styleUrls: ['./q-point-pdf-thumbnail.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        PDFViewerModule,
        CommonModule,
    ]
})
export class QPointPdfThumbnailComponent {

  @Input()
  public pdfSource: string;
  public loadComplete: boolean;

  callBackFn() {
    this.loadComplete = true;
  }
}
